import React from "react";
import ImageGallerySelector from "../pages/ImageGallerySelector";

const ImageGalleryApp = (props, rails) => () =>
  <ImageGallerySelector {...props} />;

export default ImageGalleryApp;
